import { combineReducers } from 'redux';
import baseReducer from './reducer';
import { createReducer } from '@src/api/createRequestStore';
import { IMP_BENCHMARK_KPI, IMP_BENCHMARK_SPI, SUPPORTED_METRICS } from './types';
import { BenchmarkTabKey } from '@store/overviewDashboard/kpiData/reducer';

export { SCOPE } from './types';
export const reducer = combineReducers({
  benchmark: baseReducer,
  [BenchmarkTabKey]: createReducer(IMP_BENCHMARK_KPI),
  benchmarkSPI: createReducer(IMP_BENCHMARK_SPI),
  supportedMetrics: createReducer(SUPPORTED_METRICS),
});

export { default as selectors } from './selectors';
export { default as sagas } from './sagas';
